import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import AdminNavbar from "./AdminNavbar";

const SIDEBAR_WIDTH = 150;

const AdminLayout = () => {
  return (
    <div style={{ minHeight: "100vh", background: "#fff" }}>
      
      <AdminNavbar />

      <div
        style={{
          marginLeft: SIDEBAR_WIDTH,
          padding: "20px",
          minHeight: "calc(100vh - 56px)",
          overflowX: "hidden",
        }}
      >
        <Sidebar />
        <Outlet />
      </div>
    </div>
  );
};

export default AdminLayout;

